export function getCookie(name) {
	const matches = document.cookie.match(new RegExp(
		'(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
	));

	return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setCookie(name, value, options) {
	options = options || {};

	let {expires} = options;

	if (typeof expires === 'number' && expires) {
		const d = new Date();

		d.setTime(d.getTime() + (expires * 1000));
		options.expires = d;
		expires = d;
	}

	if (expires && expires.toUTCString) {
		options.expires = expires.toUTCString();
	}

	value = encodeURIComponent(value);

	const updatedCookie = Object.keys(options).reduce(
		(upd, propName) => {
			const propValue = options[propName];

			upd += '; ' + propName;
			if (propValue !== true) {
				upd += '=' + propValue;
			}

			return upd;
		}, name + '=' + value
	);

	document.cookie = updatedCookie;
}

export function deleteCookie(name, options) {
	setCookie(name, '', {
		expires: -1, ...options
	});
}



// WEBPACK FOOTER //
// ./src/util/cookie.js